/**
 * Conversation limit ("modo cola") — who is restricted and who administers.
 * Mirrors the backend's `isRestrictedAgent` (agentScope.service.ts): every
 * role except superadmin, admin, groupadmin and AI_BOT is restricted, and an
 * unreadable role counts as restricted. A conversation-restricted user
 * (Inicio, spec S12: `conversationScope.restricted`) is restricted too,
 * whatever its role, as the backend narrows it to its seats like an agent.
 */
import { isConversationScopeRestricted } from '../conversationScope';

const UNRESTRICTED_ROLE_NAMES = ['superadmin', 'admin', 'groupadmin', 'AI_BOT'];
const LIMIT_ADMIN_ROLE_NAMES = ['superadmin', 'admin'];

const rolNameOf = (userData) => {
  const name = userData && userData.rol ? userData.rol.name : undefined;
  return typeof name === 'string' ? name : null;
};

export const isRestrictedAgent = (userData) => {
  const name = rolNameOf(userData);
  if (name === null || !UNRESTRICTED_ROLE_NAMES.includes(name)) return true;
  return isConversationScopeRestricted(userData);
};

/** May see the load panel, edit the config and force an assignment. */
export const isLimitAdmin = (userData) => LIMIT_ADMIN_ROLE_NAMES.includes(rolNameOf(userData));
